/* nv-buyform-ajax.js — Nacao Verde
   ---------------------------------------------------------------------------
   As PDPs proprias (NAC, 5M, 6M, Testomega) montam o botao de compra como um
   formulario HTML comum que faz POST em /cart/add. A compra funciona, mas esse
   caminho nao passa pela Ajax Cart API — e e nela que o web pixel da Shopify
   escuta. Resultado: o pedido entra e o evento de adicao ao carrinho nunca e
   emitido, entao GA4, Meta e Google Ads perdem o degrau do meio do funil.

   Este arquivo intercepta o envio desses formularios e refaz o mesmo pedido
   por /cart/add.js, que e o caminho instrumentado.

   Duas travas de seguranca:
   - se outro script ja tratou o evento (o app de bundle, por exemplo), saimos
     sem fazer nada e ele continua no comando;
   - qualquer falha que nao saibamos nomear cai no envio nativo do formulario,
     que e exatamente o comportamento anterior. O cliente nunca fica travado.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var SELETOR = 'form[id^="nac-form-"], form[id^="nv-form-"]';
  var ROTA_ADD = '/cart/add.js';
  var ROTA_CART = '/cart';

  if (!window.fetch || !window.FormData) return;

  function botoesDe(form) {
    var lista = [].slice.call(form.querySelectorAll('[type="submit"]'));
    if (form.id) {
      lista = lista.concat([].slice.call(
        document.querySelectorAll('[form="' + form.id + '"]')
      ));
    }
    return lista;
  }

  function ocupado(form, estado) {
    botoesDe(form).forEach(function (b) {
      b.setAttribute('aria-busy', String(estado));
      b.disabled = estado;
      b.style.opacity = estado ? '0.72' : '';
      b.style.cursor = estado ? 'progress' : '';
    });
  }

  function caixaErro(form) {
    var el = form.querySelector('[data-nv-buyerro]');
    if (el) return el;
    el = document.createElement('p');
    el.setAttribute('data-nv-buyerro', '');
    el.setAttribute('role', 'alert');
    el.setAttribute('aria-live', 'polite');
    el.style.cssText = 'margin:12px 0 0;padding:12px 16px;border-radius:12px;' +
      'background:#FDECEA;color:#8A1C13;font-size:14.5px;line-height:1.45';
    form.appendChild(el);
    return el;
  }

  function mostrarErro(form, msg) {
    var el = caixaErro(form);
    el.textContent = msg;
    el.hidden = false;
  }

  function limparErro(form) {
    var el = form.querySelector('[data-nv-buyerro]');
    if (el) el.hidden = true;
  }

  function atualizarContador(qtd) {
    var alvos = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < alvos.length; i++) alvos[i].textContent = qtd;
  }

  function tratar(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches(SELETOR)) return;
    if (event.defaultPrevented) return;

    event.preventDefault();
    limparErro(form);
    ocupado(form, true);

    var carga = new FormData(form);
    carga.delete('return_to'); /* so faz sentido no envio nativo */

    fetch(ROTA_ADD, {
      method: 'POST',
      body: carga,
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, dados: d }; });
      })
      .then(function (res) {
        if (!res.ok) {
          /* A Shopify recusou por um motivo que ela sabe explicar: sem estoque,
             limite por pedido. Mostrar o motivo e melhor do que recarregar. */
          var e = new Error(res.dados.description || res.dados.message || '');
          e.doCarrinho = true;
          throw e;
        }
        return fetch(ROTA_CART + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (c) { atualizarContador(c.item_count); })
          .catch(function () { /* contador e cosmetico */ })
          .then(function () { window.location.href = ROTA_CART; });
      })
      .catch(function (e) {
        ocupado(form, false);
        if (e && e.doCarrinho) {
          mostrarErro(form, e.message || 'Nao foi possivel adicionar ao carrinho. Tente de novo.');
          return;
        }
        /* Falha de rede ou algo que nao sabemos nomear: envio nativo. */
        HTMLFormElement.prototype.submit.call(form);
      });
  }

  document.addEventListener('submit', tratar, false);
})();
